 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER1AUNTSU from '@/components/0_chapter1auntsu'
 import A_CHAPTER2UPPERSTREET from '@/components/1_chapter2upperstreet'
 import A_CHAPTER3CONTACT from '@/components/2_chapter3contact'
 import A_CHAPTER4YOUAREMYMAN from '@/components/3_chapter4youaremyman'
 import A_CHAPTER5MEET from '@/components/4_chapter5meet'
 import A_CHAPTER6MASSAGE from '@/components/5_chapter6massage'
 import A_CHAPTER7YOURELUCKY from '@/components/6_chapter7yourelucky'
 import A_CHAPTER8SORRY from '@/components/7_chapter8sorry'
 import A_CHAPTER9STRIKE from '@/components/8_chapter9strike'
 import A_CHAPTER10SLAGMAN from '@/components/9_chapter10slagman'
 import A0_CHAPTER11SUYA from '@/components/10_chapter11suya'
 import A1_CHAPTER12MOREANDMOREINTENSE from '@/components/11_chapter12moreandmoreintense'
 import A2_CHAPTER13DOOR from '@/components/12_chapter13door'
 import A3_CHAPTER14DOUBT from '@/components/13_chapter14doubt'
 import A4_CHAPTER15SUYASWORDS from '@/components/14_chapter15suyaswords'
 import A5_CHAPTER16SCHEDULE from '@/components/15_chapter16schedule'
 import A6_CHAPTER17HARMFULVISITORS from '@/components/16_chapter17harmfulvisitors'
 import A7_CHAPTER18CONTACTAUNTSUAGAIN from '@/components/17_chapter18contactauntsuagain'
 import A8_CHAPTER19SECRETS from '@/components/18_chapter19secrets'
 import A9_CHAPTER20EXCUSE from '@/components/19_chapter20excuse'
 import A0_CHAPTER21PSYCHOLOGICALDISORDER from '@/components/20_chapter21psychologicaldisorder'
 import A1_CHAPTER22SHADOW from '@/components/21_chapter22shadow'
 import A2_CHAPTER23CONFUSION from '@/components/22_chapter23confusion'
 import A3_CHAPTER24PERSUASION from '@/components/23_chapter24persuasion'
 import A4_CHAPTER25HEARTSOUND from '@/components/24_chapter25heartsound'
 import A5_CHAPTER26DEMONS from '@/components/25_chapter26demons'
 import A6_CHAPTER27TRUTH from '@/components/26_chapter27truth'
 import A7_CHAPTER28DISPUTE from '@/components/27_chapter28dispute'
 import A8_CHAPTER29SHOW from '@/components/28_chapter29show'
 import A9_CHAPTER30CRAZY from '@/components/29_chapter30crazy'
 import A0_CHAPTER31THIS from '@/components/30_chapter31this'
 import A1_CHAPTER32DESPAIR from '@/components/31_chapter32despair'
 import A2_CHAPTER33END from '@/components/32_chapter33end'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter1auntsu",
 			"name" : "0_chapter1auntsu",
 			"component" : A_CHAPTER1AUNTSU
 		},
 		{
 			"path" : "/1_chapter2upperstreet",
 			"name" : "1_chapter2upperstreet",
 			"component" : A_CHAPTER2UPPERSTREET
 		},
 		{
 			"path" : "/2_chapter3contact",
 			"name" : "2_chapter3contact",
 			"component" : A_CHAPTER3CONTACT
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js